import accurateCalc from 'accurate-core'
import dayjs from 'dayjs'
import { IMAGE_CDN } from '~/configs'
import { round } from 'lodash'
import { isPngReg } from './regex'

const isProd = process.env.NEXT_PUBLIC_NODE_ENV === 'production'

// 缩略图
const toViewImage = (url: string, width: number) => {
  return `${url}?imageView2/2/w/${width}/q/75/format/webp`
}

export const to400Image = (url: string) => {
  return toViewImage(url, 400)
}

export const to800Image = (url: string) => {
  return toViewImage(url, 800)
}

export const to1200Image = (url: string) => {
  return toViewImage(url, 1200)
}

export const to1440Image = (url: string) => {
  return toViewImage(url, 1440)
}

/** 备注：老板觉得一些图模糊 */
export const toFullImage = (url: string) => {
  return `${url}?imageView2/2/q/100/format/webp`
}

// 带水印的图
export const toMarkImage = (url: string) => {
  return `${url}?imageView2/2/w/1200/q/75/format/webp|watermark/1/image/aHR0cHM6Ly9kYXRhLnd1amllYmFudHUuY29tL2xvZ28lRTYlQjAlQjQlRTUlOEQlQjAlMjAyLnBuZw==/dissolve/100/gravity/SouthWest/wst/1/ws/0.083`
}

/**图片用wencdn*/
export const toCDNImage = (url: string) => {
  return isProd ? IMAGE_CDN + url : url
}

/**处理富文本换行*/
export const toHtml = (content: string) => {
  return content.replace(/\n/g, '<br/>')
}

export const FenToYuan = (num: number | string | undefined | null) => {
  return accurateCalc.divide(Number(num), 100).toFixed(2)
}

export const YuanToFen = (num: number | string | undefined | null) => {
  return accurateCalc.mul(Number(num), 100)
}

export const numThousandSplit = (value: number | string) => {
  if (isNaN(Number(value)) || !value) return '0'
  value = value.toString()
  const format = /(?!\b)(?=(\d{3})+$)/g
  const arr = value.split('.')
  arr[0] = arr[0].replace(format, ',')
  value = arr.join('.')
  return value
}

export const showNickName = (args: string | undefined | null) => {
  if (args === null || args === undefined) return ''

  if (args.length > 2) {
    return args?.substring(0, 1) + '*' + args?.substring(args.length - 1)
  } else {
    return args?.substring(0, 1) + '*'
  }
}

export const showMobile = (args: number | string | undefined | null) => {
  return args?.toString().replace(/^(.{3})(?:\w+)(.{4})$/, '$1****$2')
}

export const showRealName = (args: string | undefined | null) => {
  if (args === null || args === undefined) return ''

  return (
    args?.substring(0, 1) + args?.substring(1, args?.length).replace(/./g, '*')
  )
}

export const showIdCard = (args: number | string | undefined | null) => {
  return args?.toString().replace(/^(.{2})(?:\w+)(.{2})$/, '$1**************$2')
}

export const showChainHash = (args: string | undefined | null) => {
  return args?.toString().replace(/^(.{12})(?:\w+)(.{8})$/, '$1...$2')
}

export const hexToRgba = (hex: string, opacity: number = 1) => {
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  let color = hex.toLowerCase()
  if (reg.test(color)) {
    if (color.length === 4) {
      let colorNew = '#'
      for (let i = 1; i < 4; i++) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1))
      }
      color = colorNew
    }
    const colorChange = []
    for (let i = 1; i < 7; i += 2) {
      colorChange.push(parseInt(`0x${color.slice(i, i + 2)}`, 16))
    }
    return `rgba(${colorChange.join(',')},${opacity})`
  }
  return color
}

export const blobToArrayBuffer = async (blob: Blob) => {
  if ('arrayBuffer' in blob) return await blob.arrayBuffer()

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = event => resolve(event?.target?.result)
    reader.onerror = () => reject()
    reader.readAsArrayBuffer(blob)
  })
}

export const toYMDHms = (timestrap: number) => {
  return dayjs(timestrap * 1000).format('YYYY-MM-DD HH:mm:ss')
}

export const toYMDHm = (timestrap: number) => {
  return dayjs(timestrap * 1000).format('YYYY-MM-DD HH:mm')
}

export const toYMD = (timestrap: number) => {
  return dayjs(timestrap * 1000).format('YYYY-MM-DD')
}

export const toHm = (timestrap: number) => {
  return dayjs(timestrap * 1000).format('HH:mm')
}

export function timeAgo(time: number) {
  const timestamp = /^[\d]+$/.test(time + '')

  if (!timestamp) {
    time = new Date(time).getTime() / 1000
  }
  const between = Date.now() / 1000 - time
  if (between < 60) {
    return '刚刚'
  } else if (between < 3600) {
    return `${~~(between / 60)} 分钟前`
  } else if (between < 86400) {
    return `${~~(between / 3600)} 小时前`
  } else if (between < 172800) {
    return `${~~(between / 86400)} 天前`
  } else {
    return dayjs(time * 1000).format('YYYY-MM-DD')
    // return dayjs(time * 1000).format('YYYY-MM-DD HH:mm')
  }
}

export const timeWithUint = (val: number) => {
  if (val <= 60) {
    return '1分钟内'
  } else if (val <= 5 * 60) {
    return '5分钟内'
  } else if (val <= 10 * 60) {
    return '10分钟内'
  } else if (val <= 30 * 60) {
    return '30分钟内'
  } else if (val <= 60 * 60) {
    return '1小时内'
  } else if (val <= 2 * 60 * 60) {
    return '2小时内'
  } else if (val <= 6 * 60 * 60) {
    return '6小时内'
  } else if (val <= 12 * 60 * 60) {
    return '12小时内'
  } else if (val <= 24 * 60 * 60) {
    return '24小时内'
  }
  return '24小时后'
}

export const timeAgoForNotification = (t: number) => {
  if (!t) return t
  // 24小时前
  if (dayjs.unix(t).add(1, 'day').isBefore(dayjs())) {
    return dayjs.unix(t).format('YYYY-MM-DD HH:mm')
  }
  return timeAgo(t).replace(/s/g, '')
}

export const RateToTen = (num: number | string | undefined | null) => {
  if (!num || Number(num) % 10 !== 0) return num
  return accurateCalc.divide(Number(num), 10)
}

/**
 * 给n左侧填充0，返回总长度为totalLen的字符串，
 * @param n
 * @param totalLen < 0
 */
export function padLeftWithZero(n: number | string, totalLen: number) {
  return ('00000000' + n).slice(-totalLen)
}

/**
 *
 * @param val 值
 * @param precision 精度，0:整数，以第1位小数四舍五入，1: 1位小数，以第2位小数四舍五入
 * @returns
 */
export const digitalUnit = (val: any, precision: number = 1) => {
  const num = Number(val)
  if (num <= 9999) return `${num}`
  if (num >= 99999500 && num <= 99999999)
    return `${Number(1).toFixed(precision)}亿`
  if (num > 99999999) {
    return `${round(num / 100000000, precision)}亿`
  } else {
    return `${round(num / 10000, precision)}万`
  }
}

/**
 * 字符串截取指定长度，并用...代替
 * @param str 要截取的字符串
 * @param length 要截取的字符串长度
 *  */
export const strCutout = (str: string | undefined | null, length: number) => {
  if (!str) return ''

  if (str.length > length) {
    return str.substring(0, length) + '...'
  } else {
    return str
  }
}

export const fileSizeUnit = (size: number) => {
  if (!size) return '0'
  const divisor = 1024
  if (size < divisor) {
    return `${size}B`
  } else if (size < Math.pow(divisor, 2)) {
    return `${Number.parseFloat(
      accurateCalc.divide(size, divisor).toFixed(2)
    )}K`
  } else if (size < Math.pow(divisor, 3)) {
    return `${Number.parseFloat(
      accurateCalc.divide(size, Math.pow(divisor, 2)).toFixed(2)
    )}M`
  } else if (size < Math.pow(divisor, 4)) {
    return `${Number.parseFloat(
      accurateCalc.divide(size, Math.pow(divisor, 3)).toFixed(2)
    )}G`
  } else {
    return `${Number.parseFloat(
      accurateCalc.divide(size, Math.pow(divisor, 4)).toFixed(2)
    )}T`
  }
}

export const secondsToHours = (seconds: number) => {
  const bellowZero = seconds < 0
  seconds = Math.abs(seconds)
  if (!seconds) {
    return {
      duration: '0',
      durationV2: '0',
    }
  }
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds - h * 3600) / 60)
  const s = seconds % 60
  const z = (n: number) => (n > 9 ? `${n}` : `0${n}`)
  return {
    duration: `${bellowZero ? '-' : ''}${z(h)}:${z(m)}:${z(s)}`,
    durationV2: `${bellowZero ? '-' : ''} ${z(h)} 小时 ${z(m)} 分钟 ${z(s)} 秒`,
  }
}

/** png图片格式 */
const isPng = (imgUrl: string) => {
  return isPngReg.test(imgUrl)
}

/** 添加透明背景图：style:{background: xxx }样式 */
export const toTransparentBg = ({ imgUrl }: { imgUrl?: string | null }) => {
  if (!imgUrl) {
    return {}
  }

  return {
    background: isPng(imgUrl)
      ? `url(${toCDNImage(
          '/images/ai/transparent-bg.png'
        )}) center center / cover no-repeat`
      : 'none',
  }
}

export async function* iterableStreamAsync(
  stream: ReadableStream
): AsyncIterableIterator<Uint8Array> {
  const reader = stream.getReader()
  try {
    while (true) {
      const { value, done } = await reader.read()
      if (done) {
        return
      } else {
        yield value
      }
    }
  } finally {
    reader.releaseLock()
  }
}

export const formatTime = (timestrap: number, formatStr: string) => {
  return dayjs(timestrap * 1000).format(formatStr)
}

/** 格式化文件大小 */
export const getFileSize = (fileSize: number = 0) => {
  let size = '0'
  if (fileSize > 0) {
    if (fileSize < 0.1 * 1024) {
      size = fileSize.toFixed(2) + 'B'
    } else if (fileSize < 0.1 * 1024 * 1024) {
      size = (fileSize / 1024).toFixed(2) + 'KB'
    } else if (fileSize < 0.1 * 1024 * 1024 * 1024) {
      size = (fileSize / (1024 * 1024)).toFixed(2) + 'MB'
    } else {
      size = (fileSize / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
    }
  }
  return size
}
